/* global axios */
import ApiClient from '../ApiClient';

class KanbanRoutingRulesAPI extends ApiClient {
  constructor() {
    super('kanban/boards', { accountScoped: true });
  }

  index(boardId, columnId) {
    return axios.get(
      `${this.url}/${boardId}/columns/${columnId}/routing_rules`
    );
  }

  create(boardId, columnId, labelId) {
    return axios.post(
      `${this.url}/${boardId}/columns/${columnId}/routing_rules`,
      {
        label_id: labelId,
      }
    );
  }

  delete(boardId, columnId, ruleId) {
    return axios.delete(
      `${this.url}/${boardId}/columns/${columnId}/routing_rules/${ruleId}`
    );
  }
}

export default new KanbanRoutingRulesAPI();
